<template>
    <div class="container-tooltip">
        <div class="tooltip">
            <div class="tooltip-content">
                {{ content }}
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: "TooltipElement",
    props: {
        content: {
            type: String,
        },
    },
    data() {
        return {
            showTooltip: false,
        };
    },
    methods: {
        toggleTooltip() {
            this.showTooltip = !this.showTooltip;
        },
    },
};

</script>

<style scoped>
.container-tooltip {
    position: relative;
    display: inline-block;
}

.tooltip {
    position: absolute;
    bottom: 100%;
    left: 0;
    background-color: #f8f8f8;
    border: 1px solid #ccc;
    padding: 10px;
    padding: 5px 10px;
    border-radius: 4px;
    white-space: nowrap;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
}


.container-tooltip:hover .tooltip {
    opacity: 1;
}

</style>